import React from 'react'

/// @material-ui/core components
import ListItemIcon from '@material-ui/core/ListItemIcon'

//icons
import { Check } from 'react-feather'

const ListIcon = ({ icon }) => (
  <ListItemIcon>
    {icon ? <span>{icon}</span> : <Check size={14} />}
  </ListItemIcon>
)

export default ListIcon
